/* eslint-disable react/prop-types */
import { Container, Grid, styled } from "@mui/material";
import Page from '../../../components/Page';
import useLocales from "../../../hooks/useLocales";
import useSettings from "../../../hooks/useSettings";
import Layout from '../../../layouts';
import Claimnation from "../../../sections/situation/Claimnation";
import ExamSection from "../../../sections/situationExam/ExamSection";
import { SituationExamHeader } from "../../../sections/situationExam/SituationExamHeader";
import { findExamsAPI } from "../../../service/gplx.exam.service";

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
  },
}));

SituationExam.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function SituationExam({ exams }) {
  const { translate } = useLocales();

  const { themeStretch } = useSettings();

  return (
    <Page title={translate('situationExam.title')} description={translate('situationExam.description')}>
      <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
        <RootStyle>
          <SituationExamHeader />
          <Grid container my={3} >
            <Grid item xs={12} md={12}>
              <ExamSection exams={exams} />
            </Grid>
          </Grid>
          <Claimnation />
        </RootStyle>
      </Container>
    </Page >
  );
}

export async function getStaticProps() {
  // Fetch necessary data for the blog post using params.id
  const search = { page: 0, size: 50, value: '%%', orders: [{ order: 'asc', property: 'orderNo' }] };

  const { code, data: exams } = await findExamsAPI(search);

  if (code !== "200") {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      exams
    },
  };
}